/* System Map — an interactive, plain-language diagram of how the trading
   system works: every strategy, its signals, gates, exits and sizing, the
   infrastructure around it, and what the research program has tested.
   The content is a self-contained static page (public/system-map/) so it
   can be read and updated without touching React; this component frames it. */

import React from 'react';
import { Box } from '@mui/material';

const SystemMap: React.FC = () => (
  <Box sx={{ height: 'calc(100vh - 16px)', m: -1, bgcolor: '#0b0f14' }}>
    <iframe
      title="System Map"
      src={`${process.env.PUBLIC_URL || ''}/system-map/index.html`}
      style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
    />
  </Box>
);

export default SystemMap;
